/**
 * Fusion de la lista de conversaciones de la sidebar. Puro respecto a React para
 * poder probarlo sin montar el componente (mismo criterio que `lib/polling.ts`).
 */

/** Lo unico que la fusion necesita saber de un hilo: su identidad. */
interface ConIdDeHilo {
  thread_id: string;
}

/**
 * Fusiona la PRIMERA PAGINA recien sondeada con lo que ya habia en pantalla.
 *
 * La sidebar carga paginas hacia abajo con scroll infinito, pero el sondeo
 * (`iniciarSondeo`) solo vuelve a pedir la primera. Sustituir la lista entera por
 * `frescos` perderia las paginas 2, 3... en CADA refresco (la lista se encogeria
 * sola cada 5 s); concatenar sin mas duplicaria filas, porque un hilo que recibe
 * un mensaje sube a la primera pagina y seguiria estando ademas en la copia
 * antigua de la pagina 2. De ahi las dos operaciones:
 *
 * - `slice(tamanoPagina)`: descarta la version VIEJA de la primera pagina, que
 *   `frescos` acaba de reemplazar (titulos y `last_checkpoint` al dia).
 * - filtro por `thread_id`: quita de las paginas conservadas cualquier hilo que
 *   ya venga en `frescos`, que es lo que evita la fila duplicada.
 *
 * El orden se preserva: primero la pagina fresca tal cual la devuelve el backend
 * (mas reciente arriba), despues el resto de lo ya cargado en su orden original.
 */
export function fusionarPrimeraPagina<T extends ConIdDeHilo>(
  previos: T[],
  frescos: T[],
  tamanoPagina: number,
): T[] {
  const idsFrescos = new Set(frescos.map((t) => t.thread_id));
  const conservados = previos.slice(tamanoPagina).filter((t) => !idsFrescos.has(t.thread_id));
  return [...frescos, ...conservados];
}

/** Nombre de la app en la pestaña (el `<title>` de index.html). */
export const TITULO_APP = "SON·IA";

/** Titulo de la pestaña: el resumen de la conversacion activa, si ya lo hay. */
export function tituloPestana(resumen: string | null | undefined): string {
  const r = resumen?.trim();
  return r ? `${r} · ${TITULO_APP}` : TITULO_APP;
}
